import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom"
import { ArrowLeft, Copy, Check, Info, Tag } from "lucide-react"
import { Helmet } from 'react-helmet';
import authService from '../../../Services/authService';
import SEOSchema from '../../../utils/SEOSchema';


// // Sample coupon data
// const coupons = [
//   {
//     id: "FIRST50",
//     code: "FIRST50",
//     title: "50% Off on First Order",
//     description: "Get 50% off on your first order. Maximum discount of ₹500.",
//     discountType: "percentage",
//     discountValue: 50,
//     maxDiscount: 500,
//     minOrderValue: 1000,
//     expiryDate: "2025-06-30",
//     termsAndConditions: [
//       "Valid for first-time users only",
//       "Maximum discount of ₹500",
//       "Minimum order value of ₹1000",
//       "Cannot be combined with other offers",
//     ],
//     isPopular: true,
//   },
//   {
//     id: "HEALTH25",
//     code: "HEALTH25",
//     title: "25% Off on Health Packages",
//     description: "Get 25% off on all health packages. Maximum discount of ₹1000.",
//     discountType: "percentage",
//     discountValue: 25,
//     maxDiscount: 1000,
//     minOrderValue: 2000,
//     expiryDate: "2025-05-15",
//     termsAndConditions: [
//       "Valid on health packages only",
//       "Maximum discount of ₹1000",
//       "Minimum order value of ₹2000",
//       "Cannot be combined with other offers",
//     ],
//     isPopular: false,
//   },
//   {
//     id: "FLAT200",
//     code: "FLAT200",
//     title: "Flat ₹200 Off",
//     description: "Get flat ₹200 off on all tests and packages.",
//     discountType: "fixed",
//     discountValue: 200,
//     maxDiscount: 200,
//     minOrderValue: 500,
//     expiryDate: "2025-04-30",
//     termsAndConditions: [
//       "Valid on all tests and packages",
//       "Minimum order value of ₹500",
//       "Cannot be combined with other offers",
//     ],
//     isPopular: true,
//   },
//   {
//     id: "SENIOR20",
//     code: "SENIOR20",
//     title: "20% Off for Senior Citizens",
//     description: "Senior citizens get 20% off on all tests and packages.",
//     discountType: "percentage",
//     discountValue: 20,
//     maxDiscount: 800,
//     minOrderValue: 1000,
//     expiryDate: "2025-12-31",
//     termsAndConditions: [
//       "Valid for senior citizens only (age 60+)",
//       "ID verification required at sample collection",
//       "Maximum discount of ₹800",
//       "Minimum order value of ₹1000",
//     ],
//     isPopular: false,
//   },
//   {
//     id: "FAMILY15",
//     code: "FAMILY15",
//     title: "15% Off on Family Packages",
//     description: "Get 15% off when booking tests for 3 or more family members.",
//     discountType: "percentage",
//     discountValue: 15,
//     maxDiscount: 1500,
//     minOrderValue: 3000,
//     expiryDate: "2025-07-31",
//     termsAndConditions: [
//       "Valid when booking for 3 or more family members",
//       "Maximum discount of ₹1500",
//       "Minimum order value of ₹3000",
//     ],
//     isPopular: true,
//   },
//   {
//     id: "WELCOME300",
//     code: "WELCOME300",
//     title: "₹300 Off for New Users",
//     description: "New users get ₹300 off on their first booking.",
//     discountType: "fixed",
//     discountValue: 300,
//     maxDiscount: 300,
//     minOrderValue: 800,
//     expiryDate: "2025-06-15",
//     termsAndConditions: [
//       "Valid for new users only",
//       "Minimum order value of ₹800",
//       "Cannot be combined with other offers",
//     ],
//     isPopular: false,
//   },
// ]

export default function CouponsPage() {
  const [copiedCode, setCopiedCode] = useState(null)
  const [expandedCoupon, setExpandedCoupon] = useState(null)
  const [Offers, setOffers] = useState([]);
  const token = authService.getCurrentUsertoken();

  useEffect(() => {

    loadOffers();

  }, []);

  const loadOffers = () => {

    const url = new URL(authService.getApiUrl() + 'alloffers');

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
          return res.json();
        //}
      })
      .then((result) => {
        setOffers(result.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code)
    setCopiedCode(code)
    setTimeout(() => setCopiedCode(null), 2000)
  }

  const toggleCouponDetails = (couponId) => {
    if (expandedCoupon === couponId) {
      setExpandedCoupon(null)
    } else {
      setExpandedCoupon(couponId)
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
  }

  return (
    <>
      <Helmet>
        <title>Coupons & Offers - Vithyou</title>
        <meta name="description" content="View and apply available coupons and offers for medical tests on Pranaam 365." />
      </Helmet>
      
      <SEOSchema 
        type="webpage"
        data={{
          title: "Coupons & Offers - Vithyou",
          description: "Available coupons and discount offers for medical tests",
          url: window.location.href
        }}
      />
    
    <div className="min-h-screen bg-[#F5F5F7]">

      <div className="max-w-3xl mx-auto px-4 py-6">
        {/* Back Button */}
        <Link to="/cart" className="flex items-center text-[#4A4A4A] hover:text-[#951C25] mb-6">
          <ArrowLeft size={18} className="mr-2" />
          <span>Back to Cart</span>
        </Link>

        {/* Page Title */}
        <div className="flex items-center mb-6">
          <Tag size={24} className="text-[#951C25] mr-3" />
          <h1 className="text-2xl font-semibold text-[#4A4A4A]">Available Coupons</h1>
        </div>

        {/* Coupons List */}
        <div className="space-y-4">
          {Offers.map((coupon) => (
            <div key={coupon.id} className="bg-white rounded-lg border border-[#E0E0E0] overflow-hidden">
              {/* Coupon Header */}
              <div className="p-4 border-b border-[#E0E0E0]">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="flex items-center">
                      <h2 className="text-lg font-medium text-[#4A4A4A]">{coupon.offer_title}</h2>
                      {/* {coupon.isPopular && (
                        <span className="ml-2 text-xs bg-[#951C25]/10 text-[#951C25] px-2 py-0.5 rounded">Popular</span>
                      )} */}
                    </div>
                    <p className="text-sm text-[#4A4A4A]/70 mt-1">Discount {coupon.discount_percentage}%</p>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className="flex items-center mb-2">
                      <div className="px-3 py-1.5 bg-[#F5F5F7] border border-[#E0E0E0] rounded mr-2 font-mono text-sm">
                        {coupon.coupon_code}
                      </div>
                      <button
                        onClick={() => handleCopyCode(coupon.coupon_code)}
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-[#951C25]/10 text-[#951C25] hover:bg-[#951C25]/20"
                      >
                        {copiedCode === coupon.coupon_code ? <Check size={16} /> : <Copy size={16} />}
                      </button>
                    </div>
                    {/* <button className="px-4 py-1.5 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90">
                      Apply
                    </button> */}
                  </div>
                </div>
              </div>

              {/* Coupon Details */}
              <div className="px-4 py-3 bg-[#F5F5F7]/50 flex justify-between items-center">
                <div className="flex items-center">
                  {/* <div className="flex items-center mr-4">
                    <span className="text-xs text-[#4A4A4A]/70 mr-1">Min. Order:</span>
                    <span className="text-sm font-medium text-[#4A4A4A]">₹{coupon.minOrderValue}</span>
                  </div> */}
                  <div className="flex items-center">
                    <span className="text-xs text-[#4A4A4A]/70 mr-1">Valid till:</span>
                    <span className="text-sm font-medium text-[#4A4A4A]">{formatDate(coupon.end_date)}</span>
                  </div>
                </div>
                <button
                  onClick={() => toggleCouponDetails(coupon.id)}
                  className="flex items-center text-xs text-[#951C25]"
                >
                  <Info size={14} className="mr-1" />
                  {expandedCoupon === coupon.id ? "Hide Details" : "View Details"}
                </button>
              </div>

              {/* Expanded Terms and Conditions */}
              {expandedCoupon === coupon.id && (
                <div className="p-4 bg-[#F5F5F7]/30 border-t border-[#E0E0E0]">
                  <h3 className="text-sm font-medium text-[#4A4A4A] mb-2">Terms & Conditions</h3>
                  <ul className="list-disc list-inside space-y-1">
                    {coupon.offerdetails.map((term, index) => (
                      <li key={index} className="text-xs text-[#4A4A4A]/70">
                        {term.details}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* No Coupons Message (shown when there are no coupons) */}
        {Offers.length === 0 && (
          <div className="bg-white rounded-lg border border-[#E0E0E0] p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-[#951C25]/10 flex items-center justify-center mx-auto mb-4">
              <Tag size={24} className="text-[#951C25]" />
            </div>
            <h2 className="text-lg font-medium text-[#4A4A4A] mb-2">No Coupons Available</h2>
            <p className="text-sm text-[#4A4A4A]/70">
              There are currently no active coupons available for your account.
            </p>
          </div>
        )}
      </div>
    </div>
    </>
  )
}
